<template>
  <div class="sale-trend">
    <div class="line-chart">

    </div>
  </div>

</template>

<script>
import echarts from 'echarts'

export default {

  data() {
    return {
      myChart: null
    }
  },

  created() {
    this.$nextTick(() => {
      let option = {
    title: {
        text: '商品销量趋势图',
        left: 'center',
        top: 15,
        bottom: 30
    },
    tooltip: {
        trigger: 'axis'
    },

    toolbox: {
        show: true,
        feature: {
            saveAsImage: {show: true}
        }
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['周一','周二','周三','周四','周五','周六','周日']
    },
    yAxis: {
        type: 'value'
    },
    series: [{
        name: '用户',
        type: 'line',
        // smooth: true,
        data: [10, 12, 21, 54, 260, 830, 710]
    }]
    };
    this.myChart = echarts.init(document.querySelector('.sale-trend .line-chart'))
    this.myChart.setOption(option, true)
    // this.legendArr = options.series
    // this.legendArr.forEach((data) => {
    //   data.selected = true;
    // })
    window.addEventListener('resize', function() {
      this.myChart.resize()
    }.bind(this))
    })
  },

  methods: {
    initialize(options) {

      // console.log(this.myChart);
    }
  }
}
</script>

<style scoped lang="scss">
.sale-trend {
  .line-chart {
    width: 100%;
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/sales/sales-trend.vue